import { browserTracingIntegration, init, replayIntegration, sessionTimingIntegration, setUser } from '@sentry/browser';
const allowedLandscapes = ['dev', 'int'];
// Query params that commonly carry credentials or user identifiers.
// Values are replaced with [Filtered] rather than removed so the request
// shape stays recognizable for debugging.
export const SENSITIVE_QUERY_PARAMS = [
    // OAuth / OIDC tokens and secrets
    'access_token',
    'id_token',
    'id_token_hint',
    'refresh_token',
    'token',
    'code',
    'code_verifier',
    'client_secret',
    'client_assertion',
    'assertion',
    // OIDC flow params carrying user identity
    'state',
    'session_state',
    'login_hint',
    // PII fields
    'email',
    'username',
    'password',
    // Signed/presigned URL secrets
    'authorization',
    'signature',
    'sig',
];
export const stripSensitiveQueryParams = (rawUrl) => {
    try {
        const url = new URL(rawUrl, globalThis.location.origin);
        for (const param of SENSITIVE_QUERY_PARAMS) {
            if (url.searchParams.has(param)) {
                url.searchParams.set(param, '[Filtered]');
            }
        }
        // Keycloak uses response_mode=fragment — params land in the hash, not the query string.
        if (url.hash.includes('=')) {
            const hashParams = new URLSearchParams(url.hash.slice(1));
            let changed = false;
            for (const param of SENSITIVE_QUERY_PARAMS) {
                if (hashParams.has(param)) {
                    hashParams.set(param, '[Filtered]');
                    changed = true;
                }
            }
            if (changed) {
                return url.toString().split('#')[0] + '#' + hashParams.toString();
            }
        }
        return url.toString();
    }
    catch {
        return rawUrl;
    }
};
if (allowedLandscapes.includes(window.bifrostWeb.landscape)) {
    window.bifrostSentry = init({
        dsn: window.bifrostWeb.sentry.url,
        environment: window.bifrostWeb.landscape,
        sendDefaultPii: false,
        integrations: [
            browserTracingIntegration(),
            replayIntegration({
                maskAllText: true,
                maskAllInputs: true,
                blockAllMedia: false,
                networkDetailAllowUrls: ['bf.cinemo.com'],
            }),
            sessionTimingIntegration(),
        ],
        beforeSend(event) {
            const isDev = Boolean(localStorage.getItem('devtools'));
            if (isDev) {
                return null;
            }
            return event;
        },
        beforeBreadcrumb(breadcrumb) {
            if ((breadcrumb.category === 'fetch' || breadcrumb.category === 'xhr') &&
                typeof breadcrumb.data?.url === 'string') {
                breadcrumb.data.url = stripSensitiveQueryParams(breadcrumb.data.url);
            }
            if (breadcrumb.category === 'navigation') {
                if (typeof breadcrumb.data?.from === 'string') {
                    breadcrumb.data.from = stripSensitiveQueryParams(breadcrumb.data.from);
                }
                if (typeof breadcrumb.data?.to === 'string') {
                    breadcrumb.data.to = stripSensitiveQueryParams(breadcrumb.data.to);
                }
            }
            return breadcrumb;
        },
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
    });
}
export const setSentryUser = () => {
    const id = window.bifrostAuth.accessTokenPayload?.sub;
    setUser({ id });
};
